import { IIconComponent } from 'interfaces';
import React from 'react';

export const logoutIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="12"
    viewBox="0 0 12 12"
  >
    <g>
      <g opacity=".8">
        <path
          fill="currentColor"
          d="M-1 .667v10.666c0 .369.296.667.662.667h8.382a.664.664 0 0 0 .662-.667V8.667A.664.664 0 0 0 8.044 8a.664.664 0 0 0-.662.667v2H.324V1.333h7.058v2c0 .368.297.667.662.667a.664.664 0 0 0 .662-.667V.667A.664.664 0 0 0 8.044 0H-.338A.664.664 0 0 0-1 .667zm11.003 6.87a.672.672 0 0 0 0 .944.657.657 0 0 0 .936 0l1.985-2.004.002-.002a.685.685 0 0 0 .042-.047l.018-.024.02-.028.018-.03.015-.026.015-.03c.004-.01.01-.02.013-.03l.011-.03.011-.031.008-.03.008-.033.005-.036.004-.029a.68.68 0 0 0 .004-.065v-.002a.68.68 0 0 0-.004-.065c0-.01-.003-.02-.004-.03l-.005-.034-.008-.034-.008-.03-.011-.032-.01-.03-.014-.029-.014-.03c-.005-.01-.011-.018-.017-.027-.005-.01-.01-.02-.017-.029l-.021-.03-.017-.022a.658.658 0 0 0-.044-.05L10.939 3.53a.657.657 0 0 0-.936 0 .672.672 0 0 0 0 .945l.855.863H3.191a.665.665 0 0 0-.661.668c0 .369.296.668.661.668h7.667z"
        />
      </g>
    </g>
  </svg>
);
export const userIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="12"
    viewBox="0 0 10 12"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M10 12H0c0-2.785 2.239-5.043 5-5.043S10 9.215 10 12zM2.241 2.783C2.241 1.246 3.476 0 5 0c1.524 0 2.759 1.246 2.759 2.783 0 1.536-1.235 2.782-2.759 2.782-1.524 0-2.759-1.246-2.759-2.782z"
        />
      </g>
    </g>
  </svg>
);
// MENU
export const menuIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="20"
    viewBox="0 0 26 20"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M0 18a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zM0 1a1 1 0 0 1 1-1h24a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm0 8.5a1 1 0 0 1 1-1h24a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1z"
        />
      </g>
    </g>
  </svg>
);
export const menuCollapsedIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="20"
    viewBox="0 0 26 20"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M0 18a1 1 0 0 1 1-1h24a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zM0 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm0 8.5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1z"
        />
      </g>
    </g>
  </svg>
);
export const dashboardIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M20 10c0 1.226-.221 2.4-.625 3.485a.484.484 0 0 1-.647.276l-7.69-3.397a.363.363 0 0 1-.113-.587l6.054-6.193a.48.48 0 0 1 .714.028A9.958 9.958 0 0 1 20 10zm-3.87-7.222l-6.124 6.265a.363.363 0 0 1-.566-.056L4.899 1.981a.482.482 0 0 1 .167-.681A9.951 9.951 0 0 1 10 0c2.286 0 4.392.767 6.077 2.058.23.176.256.513.053.72zm-1.403-.238A8.775 8.775 0 0 0 10 1.17c-1.284 0-2.551.28-3.707.813l3.581 5.522zm3.632 12.95a10.037 10.037 0 0 1-4.553 3.76A9.862 9.862 0 0 1 10 20C4.477 20 0 15.523 0 10c0-2.794 1.2-5.496 3.252-7.378a.48.48 0 0 1 .73.093L8.702 10l.423.651c.087.135.211.241.358.306l8.668 3.827c.272.12.371.457.207.706zm-1.459.02l-7.888-3.483a1.988 1.988 0 0 1-.868-.74l-.422-.65-4.258-6.57a8.998 8.998 0 0 0-1.537 2.374A8.88 8.88 0 0 0 1.17 10a8.801 8.801 0 0 0 2.586 6.244A8.803 8.803 0 0 0 10 18.83c1.17 0 2.329-.227 3.352-.658l.004-.002.004-.002a8.883 8.883 0 0 0 3.54-2.658zM18.83 10a8.798 8.798 0 0 0-1.571-5.03l-4.685 4.794 5.93 2.62A8.822 8.822 0 0 0 18.83 10z"
        />
      </g>
    </g>
  </svg>
);
export const buzzIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M17.49 3.096v8.787a.586.586 0 0 1-.586.586H3.096a.586.586 0 0 1-.585-.586V3.096c0-.323.262-.585.585-.585h13.808c.323 0 .585.262.586.585zm-1.172.586H8.432l1.945 3.943L12.03 5.27a.586.586 0 0 1 .48-.25h.001c.191.001.37.095.48.253l3.326 4.79zm-.57 7.615l-3.24-4.667-1.54 2.193 1.22 2.474zM7.489 4.42l-3.391 6.876h6.783zm-.627 10.558a.586.586 0 0 1 0-1.172h6.276a.586.586 0 1 1 0 1.172zm9.372 1.925a.586.586 0 0 1-.586.586H4.352a.586.586 0 0 1 0-1.172h11.296c.324 0 .586.262.586.586zM20 2.155v15.69A2.157 2.157 0 0 1 17.845 20H2.155A2.157 2.157 0 0 1 0 17.845V2.155C0 .967.967 0 2.155 0h15.69C19.033 0 20 .967 20 2.155zm-1.172 0a.984.984 0 0 0-.983-.983H2.155a.984.984 0 0 0-.983.983v15.69c0 .542.44.983.983.983h15.69a.984.984 0 0 0 .983-.983zM3.682 3.682v5.809l2.865-5.809z"
        />
      </g>
    </g>
  </svg>
);
export const surveyIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M20 10c0 5.514-4.486 10-10 10S0 15.514 0 10 4.486 0 10 0a9.932 9.932 0 0 1 7.096 2.954.833.833 0 1 1-1.182 1.174A8.277 8.277 0 0 0 10 1.667c-4.595 0-8.333 3.738-8.333 8.333 0 4.595 3.738 8.333 8.333 8.333 4.595 0 8.333-3.738 8.333-8.333A.834.834 0 0 1 20 10zm-5.67-1.492l-4.162 4.174a.827.827 0 0 1-1.177 0l-2.08-2.087a.836.836 0 0 1 0-1.18.83.83 0 0 1 1.176 0L9.58 10.91l3.573-3.583a.83.83 0 0 1 1.176 0 .836.836 0 0 1 0 1.18z"
        />
      </g>
    </g>
  </svg>
);
export const communityIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M20 17.656A2.346 2.346 0 0 1 17.656 20a2.346 2.346 0 0 1-2.343-2.344c0-.434.119-.84.325-1.19l-1.516-1.515A6.417 6.417 0 0 1 10 16.445a6.417 6.417 0 0 1-4.122-1.494l-1.516 1.516A2.346 2.346 0 0 1 2.344 20 2.346 2.346 0 0 1 0 17.656a2.346 2.346 0 0 1 2.344-2.343c.434 0 .84.119 1.19.325l1.515-1.516A6.416 6.416 0 0 1 3.555 10c0-1.566.562-3.004 1.494-4.122L3.533 4.362a2.33 2.33 0 0 1-1.19.325A2.346 2.346 0 0 1 0 2.345 2.346 2.346 0 0 1 2.344 0a2.346 2.346 0 0 1 2.344 2.344c0 .434-.12.84-.326 1.19l1.516 1.515A6.416 6.416 0 0 1 10 3.555c1.566 0 3.004.562 4.122 1.494l1.516-1.516a2.33 2.33 0 0 1-.325-1.19A2.346 2.346 0 0 1 17.656 0 2.346 2.346 0 0 1 20 2.344a2.346 2.346 0 0 1-2.344 2.344 2.33 2.33 0 0 1-1.19-.326l-1.515 1.516A6.416 6.416 0 0 1 16.445 10a6.417 6.417 0 0 1-1.494 4.122l1.516 1.516a2.33 2.33 0 0 1 1.19-.325A2.346 2.346 0 0 1 20 17.656zM16.484 2.344a1.173 1.173 0 0 0 2.344 0 1.173 1.173 0 0 0-2.344 0zM2.344 3.516a1.173 1.173 0 0 0 0-2.344 1.173 1.173 0 0 0 0 2.344zM4.727 10c0 1.56.681 2.964 1.762 3.93A3.52 3.52 0 0 1 10 10.587a3.52 3.52 0 0 1 3.511 3.345A5.261 5.261 0 0 0 15.273 10 5.28 5.28 0 0 0 10 4.727 5.28 5.28 0 0 0 4.727 10zm-1.211 7.656a1.173 1.173 0 0 0-2.344 0 1.173 1.173 0 0 0 2.344 0zM10 15.273c.841 0 1.637-.198 2.344-.55v-.621A2.346 2.346 0 0 0 10 11.758a2.346 2.346 0 0 0-2.344 2.344v.621c.707.352 1.503.55 2.344.55zm0-4.687a2.346 2.346 0 0 1-2.344-2.344A2.346 2.346 0 0 1 10 5.898a2.346 2.346 0 0 1 2.344 2.344A2.346 2.346 0 0 1 10 10.586zm1.172-2.344a1.173 1.173 0 0 0-2.344 0 1.173 1.173 0 0 0 2.344 0zm7.656 9.414a1.173 1.173 0 0 0-2.344 0 1.173 1.173 0 0 0 2.344 0z"
        />
      </g>
    </g>
  </svg>
);
export const usersIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 75 75"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M61.679 60.107c0-9.07-6.456-15.132-13.734-15.919a16.58 16.58 0 0 0 4.943-11.824c0-.154-.016-.304-.046-.449-.612-7.926-7.257-14.188-15.337-14.188-8.482 0-15.383 6.901-15.383 15.384 0 4.234 1.681 8.173 4.735 11.101-7.165.875-13.526 6.88-13.526 15.895-5.54-5.922-8.936-13.872-8.936-22.601 0-18.258 14.853-33.111 33.11-33.111 18.257 0 33.11 14.853 33.11 33.11 0 8.73-3.397 16.68-8.936 22.602zM26.514 33.105c0-6.057 4.928-10.986 10.986-10.986 5.936 0 10.787 4.732 10.98 10.622-.187 5.995-4.774 11.041-10.386 11.335a10.977 10.977 0 0 1-11.58-10.97zm30.771 30.93a33.205 33.205 0 0 1-4.395 2.773v-7.189a2.198 2.198 0 0 0-4.396 0v9.11a32.971 32.971 0 0 1-10.989 1.876c-3.85 0-7.549-.662-10.99-1.876v-9.11a2.198 2.198 0 0 0-4.395 0v7.189a33.205 33.205 0 0 1-4.395-2.774V59.62c0-6.139 4.93-11.133 10.989-11.133h17.582c6.06 0 10.99 4.994 10.99 11.133zM37.5 0C16.85 0 0 16.853 0 37.5 0 58.338 17.047 75 37.5 75c9.959 0 19.383-3.91 26.486-11.014C71.09 56.884 75 47.477 75 37.5 75 16.85 58.147 0 37.5 0z"
        />
      </g>
    </g>
  </svg>
);

export const userFilledIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="12"
    viewBox="0 0 10 12"
  >
    <g>
      <g>
        <path
          // fill="currentColor"
          fill="#55555580"
          d="M10 12H0c0-2.785 2.239-5.043 5-5.043S10 9.215 10 12zM2.241 2.783C2.241 1.246 3.476 0 5 0c1.524 0 2.759 1.246 2.759 2.783 0 1.536-1.235 2.782-2.759 2.782-1.524 0-2.759-1.246-2.759-2.782z"
        />
      </g>
    </g>
  </svg>
);

export const contactRequestsIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M15.318 8.3a.594.594 0 0 1-.596.592H7.63a.594.594 0 0 1-.595-.592c0-.328.266-.593.595-.593h7.092c.33 0 .596.265.596.593zm0-2.438a.594.594 0 0 1-.596.593H7.63a.594.594 0 0 1-.595-.593c0-.327.266-.592.595-.592h7.092c.33 0 .596.265.596.592zm4.298 10.952a1.3 1.3 0 0 1-1.347.31l-3.381-1.156a8.505 8.505 0 0 1-3.49.85 6.155 6.155 0 0 1-4.971 2.517h-.01a6.205 6.205 0 0 1-2.632-.592l-2.328.797a1.094 1.094 0 0 1-1.134-.261c-.3-.298-.4-.731-.262-1.13l.8-2.318a6.132 6.132 0 0 1-.595-2.62A6.121 6.121 0 0 1 2.73 8.3a8.323 8.323 0 0 1 2.474-5.838 8.403 8.403 0 0 1 6.11-2.462 8.408 8.408 0 0 1 5.885 2.52 8.341 8.341 0 0 1 2.426 5.903 8.406 8.406 0 0 1-.858 3.682l1.162 3.366c.163.474.044.988-.312 1.342zm-9.707-.087a8.416 8.416 0 0 1-4.649-2.321 8.347 8.347 0 0 1-2.42-4.624 4.927 4.927 0 0 0-.809 5.73.59.59 0 0 1 .037.47l-.82 2.376 2.387-.817a.598.598 0 0 1 .472.037c.707.373 1.507.57 2.312.571h.008c1.319 0 2.56-.518 3.482-1.422zm8.893-.87l-1.243-3.603a.59.59 0 0 1 .036-.47 7.214 7.214 0 0 0 .839-3.362c.006-3.928-3.197-7.174-7.14-7.236a7.22 7.22 0 0 0-5.25 2.115A7.154 7.154 0 0 0 3.92 8.528c.062 3.922 3.316 7.108 7.256 7.108h.012a7.297 7.297 0 0 0 3.377-.834.597.597 0 0 1 .471-.037l3.62 1.238a.108.108 0 0 0 .119-.027.107.107 0 0 0 .027-.119zm-6.214-5.12a.594.594 0 0 1-.596.593H7.63a.594.594 0 0 1-.595-.593c0-.327.266-.593.595-.593h4.362c.33 0 .596.266.596.593z"
        />
      </g>
    </g>
  </svg>
);
export const categoriesIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M15.313 4.14v-.585h-1.836a.587.587 0 0 0-.586.586v5.273h2.421v-.586c0-.97.79-1.758 1.758-1.758h1.172c.97 0 1.758.789 1.758 1.758v2.344a1.76 1.76 0 0 1-1.758 1.758H17.07a1.76 1.76 0 0 1-1.758-1.758v-.586h-2.421v5.273c0 .323.262.586.586.586h1.835v-.586c0-.969.79-1.757 1.758-1.757h1.172c.97 0 1.758.788 1.758 1.757v2.344c0 .973-.786 1.797-1.758 1.797H17.07c-.973 0-1.758-.826-1.758-1.797v-.586h-1.835a1.76 1.76 0 0 1-1.758-1.758v-5.273h-1.205a5.28 5.28 0 0 1-5.24 4.687A5.28 5.28 0 0 1 0 10a5.28 5.28 0 0 1 5.273-5.273 5.28 5.28 0 0 1 5.241 4.687h1.205V4.141c0-.97.788-1.758 1.758-1.758h1.835v-.625c0-.97.79-1.758 1.758-1.758h1.172C19.212 0 20 .789 20 1.758V4.14a1.76 1.76 0 0 1-1.758 1.757H17.07a1.76 1.76 0 0 1-1.758-1.757zm1.171 0c0 .324.263.587.586.587h1.172a.587.587 0 0 0 .586-.586V1.758a.587.587 0 0 0-.586-.586H17.07a.587.587 0 0 0-.586.586zM9.375 10a4.106 4.106 0 0 0-4.102-4.102A4.106 4.106 0 0 0 1.172 10a4.106 4.106 0 0 0 4.101 4.102A4.106 4.106 0 0 0 9.375 10zm7.11 8.203c0 .333.273.625.585.625h1.172c.312 0 .586-.292.586-.625V15.86a.587.587 0 0 0-.586-.586H17.07a.587.587 0 0 0-.586.586zm0-7.031c0 .323.262.586.585.586h1.172a.587.587 0 0 0 .586-.586V8.828a.587.587 0 0 0-.586-.586H17.07a.587.587 0 0 0-.586.586zM8.03 9.242l-2.93 2.93a.586.586 0 0 1-.828 0l-1.758-1.758a.586.586 0 1 1 .829-.828l1.344 1.343 2.515-2.515a.586.586 0 1 1 .828.828z"
        />
      </g>
    </g>
  </svg>
);
export const pointsIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="18"
    viewBox="0 0 20 18"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M4.157 1.184h3.345l-1.72 4.402h-4.14zm14.201 4.402H14.22l-1.72-4.402h3.345zM14.236 6.76h3.869l-6.498 7.788zm-8.481 0l2.63 7.789-6.5-7.789zm7.206 0l-2.96 8.757L7.04 6.76zM11.2 1.184l1.72 4.402H7.082l1.72-4.402zm8.724 4.696L16.731.303A.61.61 0 0 0 16.2 0H3.8a.61.61 0 0 0-.531.303L.077 5.88a.58.58 0 0 0 .06.662l9.393 11.24.01.01.03.032.003.004.009.008.003.002a.638.638 0 0 0 .085.066l.018.01c.01.007.021.012.032.018l.013.007.012.006.038.015.023.008.005.002h.001l.017.005a.62.62 0 0 0 .062.014l.026.005c.025.003.05.005.076.005l.008.001h.007a.624.624 0 0 0 .076-.006l.026-.005a.6.6 0 0 0 .063-.014l.016-.004h.002l.004-.003.023-.008.038-.015.012-.006.013-.007a.62.62 0 0 0 .032-.017l.018-.011a.574.574 0 0 0 .086-.066l.003-.003.007-.006.004-.004a.576.576 0 0 0 .031-.034l.01-.01 9.392-11.239a.58.58 0 0 0 .059-.662z"
        />
      </g>
    </g>
  </svg>
);
export const paymentIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M14.107 4.688c-2.866 0-4.693-1.026-4.693-1.758 0-.735 1.832-1.758 4.693-1.758 2.888 0 4.731 1.041 4.731 1.758 0 .716-1.843 1.758-4.731 1.758zm-7.662 8.285c-.312 0-.586-.292-.586-.626 0-.246.155-.467.386-.551.3-.11.651.039.96.408a.585.585 0 1 0 .898-.754c-.316-.378-.685-.638-1.072-.768v-.681a.586.586 0 1 0-1.172 0v.687l-.015.005a1.766 1.766 0 0 0-1.157 1.654c0 .468.18.913.506 1.255.335.351.78.544 1.252.544a.587.587 0 0 1 .228 1.128c-.262.11-.576.016-.861-.26a.586.586 0 1 0-.816.842 2.3 2.3 0 0 0 .863.54v.684a.586.586 0 1 0 1.172 0v-.688a1.76 1.76 0 0 0-.586-3.42zM18.838 6.48c0 .715-1.843 1.753-4.731 1.753-1.33 0-2.571-.225-3.495-.634-.739-.327-1.198-.756-1.198-1.119V4.734c1.27.83 3.166 1.122 4.693 1.122 1.542 0 3.455-.299 4.731-1.13zM18.828 10c0 .717-1.841 1.758-4.726 1.758-.5 0-.987-.033-1.456-.096a6.493 6.493 0 0 0-1.599-2.655c.906.265 1.958.407 3.055.407 1.54 0 3.45-.3 4.726-1.133zm0 3.55c0 .714-1.841 1.753-4.726 1.753-.478 0-.944-.03-1.393-.088a6.356 6.356 0 0 0 .184-2.348c.395.04.799.06 1.209.06 1.54 0 3.45-.3 4.726-1.13zm.01 3.52c0 .717-1.843 1.758-4.732 1.758-1.23 0-2.39-.197-3.271-.541a6.49 6.49 0 0 0 1.454-1.938c.582.09 1.191.135 1.817.135 1.542 0 3.455-.3 4.732-1.133zM6.445 18.828a5.28 5.28 0 0 1-5.273-5.273c0-2.93 2.366-5.313 5.273-5.313a5.319 5.319 0 0 1 5.313 5.313c0 2.907-2.383 5.273-5.313 5.273zM18.085.736C17.008.261 15.593 0 14.103 0c-3.05 0-5.86 1.12-5.86 2.93v4.396a6.42 6.42 0 0 0-1.797-.256 6.377 6.377 0 0 0-4.557 1.912A6.46 6.46 0 0 0 0 13.555a6.453 6.453 0 0 0 9.768 5.53c1.09.584 2.643.915 4.334.915 1.49 0 2.905-.261 3.984-.736C19.32 18.72 20 17.942 20 17.07V2.93c0-.872-.68-1.65-1.914-2.194z"
        />
      </g>
    </g>
  </svg>
);
export const offensiveWordsIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M14.451 16.245a7.56 7.56 0 0 1-4.412 1.411c-4.213 0-7.695-3.496-7.695-7.695a7.56 7.56 0 0 1 1.41-4.412.586.586 0 0 1 .892-.075l9.88 9.88a.586.586 0 0 1-.075.891zm3.205-6.284c0 1.62-.5 3.214-1.41 4.49a.586.586 0 0 1-.892.074l-9.88-9.879a.586.586 0 0 1 .075-.891c1.276-.91 2.87-1.411 4.49-1.411 4.2 0 7.617 3.417 7.617 7.617zm-1.164 0c0-3.554-2.899-6.453-6.453-6.453a6.691 6.691 0 0 0-3.217.828l8.842 8.842a6.692 6.692 0 0 0 .828-3.217zm3.508 0C20 15.42 15.591 20 10.04 20 4.531 20 0 15.459 0 9.96 0 4.416 4.574 0 10.04 0A9.955 9.955 0 0 1 20 9.96zm-1.164 0c0-4.846-3.95-8.797-8.797-8.797-4.89 0-8.875 3.95-8.875 8.797 0 4.89 3.986 8.875 8.875 8.875 4.846 0 8.797-3.986 8.797-8.875zm-5.656 5.705L4.334 6.82a6.398 6.398 0 0 0-.826 3.14c0 3.537 2.995 6.524 6.531 6.524a6.39 6.39 0 0 0 3.141-.818z"
        />
      </g>
    </g>
  </svg>
);
export const rolesIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M15.273 10A5.28 5.28 0 0 1 10 15.273 5.28 5.28 0 0 1 4.727 10 5.28 5.28 0 0 1 10 4.727 5.28 5.28 0 0 1 15.273 10zm-2.736 3.22A2.917 2.917 0 0 0 10 11.759a2.917 2.917 0 0 0-2.537 1.463c.699.551 1.58.88 2.537.88.957 0 1.838-.329 2.537-.88zM10 10.587c.646 0 1.172-.526 1.172-1.172 0-.646-.526-1.172-1.172-1.172-.646 0-1.172.526-1.172 1.172 0 .646.526 1.172 1.172 1.172zM14.102 10A4.106 4.106 0 0 0 10 5.898 4.106 4.106 0 0 0 5.898 10c0 .87.273 1.676.736 2.34a4.077 4.077 0 0 1 1.619-1.366 2.334 2.334 0 0 1-.597-1.56A2.346 2.346 0 0 1 10 7.07a2.346 2.346 0 0 1 2.344 2.344c0 .599-.226 1.145-.597 1.56a4.076 4.076 0 0 1 1.62 1.367A4.078 4.078 0 0 0 14.101 10zM20 8.828v2.344a.586.586 0 0 1-.491.578l-1.556.254a8.11 8.11 0 0 1-.914 2.202l.896 1.254a.586.586 0 0 1-.063.755l-1.657 1.657a.586.586 0 0 1-.755.063l-1.254-.896a8.108 8.108 0 0 1-2.202.914l-.254 1.556a.586.586 0 0 1-.578.491H8.828a.586.586 0 0 1-.578-.491l-.254-1.556a8.109 8.109 0 0 1-2.202-.914l-1.254.896a.586.586 0 0 1-.755-.063l-1.657-1.657a.586.586 0 0 1-.063-.755l.896-1.254a8.11 8.11 0 0 1-.914-2.202L.49 11.75A.586.586 0 0 1 0 11.172V8.828c0-.287.208-.532.491-.578l1.556-.254a8.11 8.11 0 0 1 .914-2.202L2.065 4.54a.586.586 0 0 1 .063-.755l1.657-1.657a.586.586 0 0 1 .755-.063l1.254.896a8.107 8.107 0 0 1 2.202-.914L8.25.49A.586.586 0 0 1 8.828 0h2.344c.287 0 .532.208.578.492l.254 1.555a8.11 8.11 0 0 1 2.202.914l1.254-.895a.586.586 0 0 1 .755.062l1.657 1.657a.586.586 0 0 1 .063.755l-.896 1.254a8.11 8.11 0 0 1 .914 2.202l1.556.254a.586.586 0 0 1 .491.578zm-1.172.498l-1.454-.237a.586.586 0 0 1-.48-.464A6.96 6.96 0 0 0 15.846 6.1a.586.586 0 0 1 .01-.666l.837-1.171-.956-.955-1.17.836a.586.586 0 0 1-.667.01 6.961 6.961 0 0 0-2.525-1.048.586.586 0 0 1-.464-.48l-.237-1.454H9.326L9.09 2.626a.586.586 0 0 1-.464.48A6.96 6.96 0 0 0 6.1 4.154a.586.586 0 0 1-.666-.01l-1.171-.836-.955.955.836 1.17a.586.586 0 0 1 .01.667 6.96 6.96 0 0 0-1.048 2.525.586.586 0 0 1-.48.464l-1.454.237v1.348l1.454.237c.24.04.432.225.48.464A6.96 6.96 0 0 0 4.154 13.9a.586.586 0 0 1-.01.666l-.836 1.171.955.955 1.17-.836a.586.586 0 0 1 .667-.01 6.96 6.96 0 0 0 2.525 1.048c.24.048.424.24.464.48l.237 1.454h1.348l.237-1.454a.586.586 0 0 1 .464-.48 6.96 6.96 0 0 0 2.525-1.048.586.586 0 0 1 .666.01l1.171.836.955-.955-.836-1.17a.586.586 0 0 1-.01-.667 6.96 6.96 0 0 0 1.048-2.525.586.586 0 0 1 .48-.464l1.454-.237z"
        />
      </g>
    </g>
  </svg>
);
// CARDS
export const surveyCardIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="75"
    height="75"
    viewBox="0 0 75 75"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M45.652 49.728a2.446 2.446 0 0 1-2.445 2.446h-6.522a2.446 2.446 0 1 1 0-4.891h6.522a2.446 2.446 0 0 1 2.445 2.445zm0-9.782a2.446 2.446 0 0 1-2.445 2.445H31.794a2.446 2.446 0 0 1 0-4.891h11.413a2.446 2.446 0 0 1 2.445 2.446zm0-9.783a2.446 2.446 0 0 1-2.445 2.446h-6.522a2.446 2.446 0 0 1 0-4.892h6.522a2.446 2.446 0 0 1 2.445 2.446zm-17.02 21.294l-9.783 9.783a2.446 2.446 0 0 1-3.459 0L10.5 56.35a2.446 2.446 0 0 1 3.459-3.459l3.162 3.162L25.173 48a2.446 2.446 0 0 1 3.459 3.458zm0-19.565l-9.783 9.783a2.446 2.446 0 0 1-3.459 0L10.5 36.784a2.446 2.446 0 0 1 3.458-3.459l3.162 3.162 8.054-8.053a2.446 2.446 0 0 1 3.459 3.458zM75 18.75v42.867c0 2.24-.461 2.655-5.15 12.031-.9 1.8-3.476 1.798-4.374 0-4.69-9.38-5.15-9.79-5.15-12.031V18.75c0-4.046 3.291-7.337 7.337-7.337 4.046 0 7.337 3.291 7.337 7.337zm-4.891 42.867v-1.29h-4.892v1.29c0 .767.084.744 2.446 5.469 2.367-4.733 2.446-4.704 2.446-5.469zm0-25.747h-4.892v19.565h4.892zm0-4.892V18.75a2.449 2.449 0 0 0-2.446-2.446 2.449 2.449 0 0 0-2.446 2.446v12.228zM55.435 17.12v50.543c0 4.046-3.292 7.337-7.337 7.337H7.337C3.291 75 0 71.709 0 67.663V17.12c0-4.046 3.291-7.337 7.337-7.337h3.682c1.01-2.847 3.727-4.892 6.916-4.892h2.864C21.81 2.044 24.53 0 27.717 0c3.189 0 5.909 2.044 6.918 4.891H37.5c3.188 0 5.907 2.045 6.916 4.892h3.682c4.045 0 7.337 3.291 7.337 7.337zm-39.946-2.446h24.457v-2.446A2.449 2.449 0 0 0 37.5 9.783h-4.891a2.446 2.446 0 0 1-2.446-2.446 2.449 2.449 0 0 0-2.446-2.446 2.449 2.449 0 0 0-2.445 2.446 2.446 2.446 0 0 1-2.446 2.446h-4.891a2.449 2.449 0 0 0-2.446 2.445zm35.055 52.989V17.12a2.449 2.449 0 0 0-2.446-2.446h-3.26v2.446a2.446 2.446 0 0 1-2.447 2.445H13.044a2.446 2.446 0 0 1-2.446-2.445v-2.446H7.337a2.449 2.449 0 0 0-2.446 2.446v50.543a2.449 2.449 0 0 0 2.446 2.446h40.76a2.449 2.449 0 0 0 2.446-2.446zm-4.892-8.152a2.446 2.446 0 0 1-2.445 2.446H31.794a2.446 2.446 0 1 1 0-4.892h11.413a2.446 2.446 0 0 1 2.445 2.446z"
        />
      </g>
    </g>
  </svg>
);
export const pulsesCardIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="75"
    height="75"
    viewBox="0 0 75 75"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M52.734 37.5a2.197 2.197 0 0 1-2.197 2.197H19.775a2.197 2.197 0 0 1 0-4.394h30.762c1.214 0 2.197.984 2.197 2.197zm-13.183-8.79a2.197 2.197 0 0 1-2.197 2.198H19.775a2.197 2.197 0 0 1 0-4.394h17.579c1.213 0 2.197.983 2.197 2.197zm0-8.788a2.197 2.197 0 0 1-2.197 2.197H19.775a2.197 2.197 0 0 1 0-4.394h17.579c1.213 0 2.197.983 2.197 2.197zm33.506 21.83L61.523 53.366v19.438A2.197 2.197 0 0 1 59.326 75h-48.34a2.197 2.197 0 0 1-2.197-2.197v-6.739H2.197A2.197 2.197 0 0 1 0 63.867V2.197C0 .984.984 0 2.197 0h48.34c1.214 0 2.197.984 2.197 2.197v8.105c.225.174.44.36.644.564l6.214 6.215a6.548 6.548 0 0 1 1.931 4.661v12.915l2.206-2.221c2.576-2.575 6.758-2.575 9.328-.005a6.6 6.6 0 0 1 0 9.322zM48.34 13.33v8.79h8.789v-.378c0-.587-.229-1.139-.644-1.554l-6.214-6.214a2.183 2.183 0 0 0-1.554-.644zM10.986 8.936H48.34V4.395H4.395V61.67h4.394V11.133c0-1.214.984-2.197 2.197-2.197zm46.143 61.67V57.788l-5.672 5.71a2.2 2.2 0 0 1-1.056.591l-8.15 1.916c-1.582.372-3.02-1.053-2.64-2.648l1.934-8.13c.094-.394.294-.753.58-1.04L57.128 39.08V26.514H46.143a2.197 2.197 0 0 1-2.198-2.198V13.33H13.184v57.275zM48.344 57.29A6.61 6.61 0 0 0 46.517 56l-.84.846-.968 4.068 4.073-.958.846-.851a6.61 6.61 0 0 0-1.284-1.815zm16.96-13.968l-3.107-3.107-12.475 12.56a11.01 11.01 0 0 1 3.114 3.1zm4.646-7.784a2.2 2.2 0 0 0-3.108 0l-1.548 1.559 3.107 3.107 1.543-1.553a2.201 2.201 0 0 0 .006-3.113zm-31.043 16.7L25.724 65.42a2.197 2.197 0 0 1-3.108 0l-4.394-4.395a2.197 2.197 0 1 1 3.107-3.107l2.84 2.84L35.8 49.13a2.197 2.197 0 1 1 3.108 3.107z"
        />
      </g>
    </g>
  </svg>
);
export const communityCardIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="75"
    height="75"
    viewBox="0 0 75 75"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M75 66.21c0 4.848-3.942 8.79-8.79 8.79-4.846 0-8.788-3.942-8.788-8.79a8.73 8.73 0 0 1 1.221-4.46l-5.685-5.685A24.062 24.062 0 0 1 37.5 61.67a24.062 24.062 0 0 1-15.458-5.605l-5.684 5.685a8.735 8.735 0 0 1 1.22 4.46c0 4.848-3.942 8.79-8.789 8.79C3.942 75 0 71.058 0 66.21c0-4.846 3.942-8.788 8.79-8.788 1.626 0 3.151.446 4.46 1.22l5.685-5.684A24.06 24.06 0 0 1 13.33 37.5a24.06 24.06 0 0 1 5.605-15.458l-5.685-5.684a8.735 8.735 0 0 1-4.46 1.22C3.941 17.578 0 13.636 0 8.79 0 3.942 3.942 0 8.79 0c4.846 0 8.788 3.942 8.788 8.79a8.735 8.735 0 0 1-1.22 4.46l5.684 5.685A24.06 24.06 0 0 1 37.5 13.33a24.06 24.06 0 0 1 15.458 5.605l5.684-5.685a8.735 8.735 0 0 1-1.22-4.46c0-4.848 3.942-8.79 8.789-8.79C71.058 0 75 3.942 75 8.79c0 4.846-3.942 8.788-8.79 8.788a8.735 8.735 0 0 1-4.46-1.22l-5.685 5.684A24.06 24.06 0 0 1 61.67 37.5a24.062 24.062 0 0 1-5.604 15.458l5.684 5.684a8.735 8.735 0 0 1 4.46-1.22c4.848 0 8.79 3.942 8.79 8.789zM61.816 8.79a4.4 4.4 0 0 0 4.395 4.394 4.4 4.4 0 0 0 4.394-4.395 4.4 4.4 0 0 0-4.394-4.394 4.4 4.4 0 0 0-4.395 4.394zM8.79 13.183a4.4 4.4 0 0 0 4.395-4.395 4.4 4.4 0 0 0-4.395-4.394 4.4 4.4 0 0 0-4.394 4.394 4.4 4.4 0 0 0 4.394 4.395zM17.725 37.5c0 5.851 2.555 11.116 6.607 14.74.336-6.973 6.113-12.543 13.168-12.543 7.055 0 12.832 5.57 13.168 12.543 4.052-3.624 6.607-8.889 6.607-14.74 0-10.904-8.871-19.775-19.775-19.775-10.904 0-19.775 8.871-19.775 19.775zm-4.541 28.71a4.4 4.4 0 0 0-4.395-4.394 4.4 4.4 0 0 0-4.394 4.395 4.4 4.4 0 0 0 4.394 4.394 4.4 4.4 0 0 0 4.395-4.394zM37.5 57.276c3.155 0 6.14-.743 8.79-2.064v-2.33c0-4.847-3.943-8.79-8.79-8.79-4.847 0-8.79 3.943-8.79 8.79v2.33a19.654 19.654 0 0 0 8.79 2.064zm0-17.578c-4.847 0-8.79-3.942-8.79-8.789 0-4.846 3.943-8.789 8.79-8.789 4.847 0 8.79 3.943 8.79 8.79 0 4.846-3.943 8.788-8.79 8.788zm4.395-8.789a4.4 4.4 0 0 0-4.395-4.394 4.4 4.4 0 0 0-4.395 4.394 4.4 4.4 0 0 0 4.395 4.395 4.4 4.4 0 0 0 4.395-4.395zm28.71 35.303a4.4 4.4 0 0 0-4.394-4.395 4.4 4.4 0 0 0-4.395 4.395 4.4 4.4 0 0 0 4.395 4.394 4.4 4.4 0 0 0 4.394-4.394z"
        />
      </g>
    </g>
  </svg>
);
export const userCardIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="75"
    height="75"
    viewBox="0 0 75 75"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M61.679 60.107c0-9.07-6.456-15.132-13.734-15.919a16.58 16.58 0 0 0 4.943-11.824c0-.154-.016-.304-.046-.449-.612-7.926-7.257-14.188-15.337-14.188-8.482 0-15.383 6.901-15.383 15.384 0 4.234 1.681 8.173 4.735 11.101-7.165.875-13.526 6.88-13.526 15.895-5.54-5.922-8.936-13.872-8.936-22.601 0-18.258 14.853-33.111 33.11-33.111 18.257 0 33.11 14.853 33.11 33.11 0 8.73-3.397 16.68-8.936 22.602zM26.514 33.105c0-6.057 4.928-10.986 10.986-10.986 5.936 0 10.787 4.732 10.98 10.622-.187 5.995-4.774 11.041-10.386 11.335a10.977 10.977 0 0 1-11.58-10.97zm30.771 30.93a33.205 33.205 0 0 1-4.395 2.773v-7.189a2.198 2.198 0 0 0-4.396 0v9.11a32.971 32.971 0 0 1-10.989 1.876c-3.85 0-7.549-.662-10.99-1.876v-9.11a2.198 2.198 0 0 0-4.395 0v7.189a33.205 33.205 0 0 1-4.395-2.774V59.62c0-6.139 4.93-11.133 10.989-11.133h17.582c6.06 0 10.99 4.994 10.99 11.133zM37.5 0C16.85 0 0 16.853 0 37.5 0 58.338 17.047 75 37.5 75c9.959 0 19.383-3.91 26.486-11.014C71.09 56.884 75 47.477 75 37.5 75 16.85 58.147 0 37.5 0z"
        />
      </g>
    </g>
  </svg>
);
export const contactCardIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="75"
    height="75"
    viewBox="0 0 75 75"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M57.441 31.759c0 1.252-1 2.268-2.232 2.268H28.613c-1.233 0-2.232-1.016-2.232-2.268 0-1.252 1-2.268 2.232-2.268H55.21c1.233 0 2.232 1.016 2.232 2.268zm0-9.327c0 1.253-1 2.268-2.232 2.268H28.613c-1.233 0-2.232-1.015-2.232-2.268 0-1.252 1-2.267 2.232-2.267H55.21c1.233 0 2.232 1.015 2.232 2.267zm16.12 41.907a4.826 4.826 0 0 1-3.448 1.461c-.536 0-1.077-.09-1.606-.274L55.83 61.101a31.376 31.376 0 0 1-13.09 3.255c-4.362 6.052-11.24 9.628-18.639 9.629h-.036a22.88 22.88 0 0 1-9.87-2.264l-8.731 3.048c-.445.155-.9.231-1.351.231a4.06 4.06 0 0 1-2.902-1.23 4.206 4.206 0 0 1-.984-4.32l3-8.871A23.863 23.863 0 0 1 1 50.552c-.01-7.406 3.421-14.34 9.236-18.788.103-8.443 3.375-16.344 9.275-22.338C25.628 3.211 33.766-.134 42.424.004c8.35.135 16.187 3.559 22.068 9.642 5.88 6.082 9.112 14.105 9.099 22.59a32.708 32.708 0 0 1-3.217 14.089l4.356 12.879a4.998 4.998 0 0 1-1.168 5.135zm-36.402-.332c-6.544-1.002-12.608-4.068-17.433-8.882a32.16 32.16 0 0 1-9.076-17.694 19.057 19.057 0 0 0-5.186 13.114c.004 3.068.749 6.114 2.152 8.81a2.3 2.3 0 0 1 .138 1.797l-3.076 9.096 8.953-3.126a2.202 2.202 0 0 1 1.77.14 18.436 18.436 0 0 0 8.671 2.187h.03c4.944 0 9.602-1.982 13.057-5.442zm33.35-3.33L65.844 46.89a2.3 2.3 0 0 1 .138-1.797 28.057 28.057 0 0 0 3.144-12.865c.022-15.03-11.988-27.451-26.773-27.69-7.439-.118-14.431 2.755-19.687 8.095-5.256 5.34-8.086 12.443-7.968 20 .234 15.007 12.438 27.2 27.213 27.2h.042a26.926 26.926 0 0 0 12.663-3.194 2.203 2.203 0 0 1 1.77-.14l13.57 4.738a.4.4 0 0 0 .448-.105.416.416 0 0 0 .103-.455zM47.202 41.085c0 1.252-.999 2.268-2.232 2.268H28.613c-1.233 0-2.232-1.016-2.232-2.268 0-1.252 1-2.268 2.232-2.268h16.358c1.233 0 2.232 1.016 2.232 2.268z"
        />
      </g>
    </g>
  </svg>
);

export const searchIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M16.792 15.792a.708.708 0 1 1-1.002 1l-4.087-4.084a7.123 7.123 0 0 1-4.539 1.62 7.164 7.164 0 1 1 5.54-2.622l4.088 4.086m-9.623-2.89c3.167 0 5.747-2.574 5.747-5.738 0-3.164-2.58-5.741-5.747-5.741a5.75 5.75 0 0 0-5.746 5.741c0 3.164 2.576 5.739 5.746 5.739"
        />
      </g>
    </g>
  </svg>
);
export const addIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M12.75 5.75H8.5a.25.25 0 0 1-.25-.25V1.25a1.25 1.25 0 0 0-2.5 0V5.5a.25.25 0 0 1-.25.25H1.25a1.25 1.25 0 0 0 0 2.5H5.5a.25.25 0 0 1 .25.25v4.25a1.25 1.25 0 0 0 2.5 0V8.5a.25.25 0 0 1 .25-.25h4.25a1.25 1.25 0 0 0 0-2.5z"
        />
      </g>
    </g>
  </svg>
);
export const minusIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="3"
    viewBox="0 0 16 3"
  >
    <g>
      <g>
        <path fill="currentColor" d="M0 0h16v3H0z" />
      </g>
    </g>
  </svg>
);
export const deleteIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="17"
    viewBox="0 0 12 17"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M11.252 5.628l-.447 10.841a.546.546 0 0 1-.538.531H1.733a.546.546 0 0 1-.538-.53L.748 5.627zm-6.88 2.254a.547.547 0 0 0-.539-.554.547.547 0 0 0-.538.554v6.864c0 .306.24.554.538.554a.547.547 0 0 0 .539-.554zm2.167 0a.547.547 0 0 0-.54-.554.547.547 0 0 0-.538.554v6.864c0 .306.241.554.539.554a.547.547 0 0 0 .539-.554zM12 2.26v1.705a.547.547 0 0 1-.539.554H.54A.547.547 0 0 1 0 3.965V2.26c0-.307.241-.555.539-.555h2.95V.555c0-.307.241-.555.538-.555h3.946c.297 0 .538.248.538.554v1.151h2.95c.298 0 .539.248.539.555zM7.434 1.109H4.566v.596h2.868zm1.271 6.773a.547.547 0 0 0-.538-.554.547.547 0 0 0-.54.554v6.864c0 .306.242.554.54.554a.547.547 0 0 0 .538-.554z"
        />
      </g>
    </g>
  </svg>
);
export const editIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M1.908 10.863l8.664-8.664 4.23 4.23-8.664 8.663zm-.562.85l3.94 3.94L.634 16.98a.505.505 0 0 1-.49-.126.5.5 0 0 1-.126-.49zm15.66-8.107c0 .4-.153.775-.437 1.058l-1.06 1.058-4.235-4.228 1.06-1.058c.283-.28.66-.436 1.06-.436.403 0 .776.156 1.062.44l2.117 2.112c.28.282.436.655.433 1.054z"
        />
      </g>
    </g>
  </svg>
);
export const checkIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M4.49 5.927l1.574 1.571 3.449-3.44 1.22 1.219-3.446 3.44-1.223 1.217-2.794-2.79zm7.46 6.022a6.999 6.999 0 0 0 0-9.898 6.999 6.999 0 0 0-9.9 0 6.999 6.999 0 0 0 0 9.898 6.999 6.999 0 0 0 9.9 0z"
        />
      </g>
    </g>
  </svg>
);
export const checkmarkIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="9"
    viewBox="0 0 12 9"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M10.413 0L12 1.587 4.577 9.01 0 4.434l1.587-1.587 2.99 2.99z"
        />
      </g>
    </g>
  </svg>
);
export const selectIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="8"
    viewBox="0 0 12 8"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M5.247 7.659a1 1 0 0 0 1.506 0l4.796-5.482A1 1 0 0 0 10.796.52H1.204A1 1 0 0 0 .45 2.177z"
        />
      </g>
    </g>
  </svg>
);
export const arrowBackIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M11.325 4.056l.02.004h-8.03l2.524-2.538a.66.66 0 0 0 .191-.468.659.659 0 0 0-.191-.467L5.446.192A.65.65 0 0 0 4.982 0a.65.65 0 0 0-.464.192L.191 4.532A.653.653 0 0 0 0 5c0 .178.067.343.191.468l4.327 4.341a.65.65 0 0 0 .464.192.65.65 0 0 0 .464-.192l.393-.394a.653.653 0 0 0 0-.922L3.286 5.94h8.048A.681.681 0 0 0 12 5.264v-.557c0-.363-.313-.651-.675-.651z"
        />
      </g>
    </g>
  </svg>
);
export const externalLinkIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="9"
    viewBox="0 0 9 9"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M9 1.184v3.55c0 .653-.14.643-.522.262L7.384 3.903l-1.91 1.91a1.014 1.014 0 0 1-1.434 0l-.834-.834a1.013 1.013 0 0 1 0-1.433l1.91-1.91L4.003.52C3.658.177 3.612 0 4.265 0h3.552C9.008 0 9-.006 9 1.184zM7.27 5.109v2.204C7.27 8.245 6.513 9 5.581 9H1.688A1.687 1.687 0 0 1 0 7.313V3.418c0-.932.755-1.687 1.688-1.687h2.225L2.874 2.769H1.687a.65.65 0 0 0-.649.65v3.894a.65.65 0 0 0 .65.649h3.894a.65.65 0 0 0 .649-.65V6.148z"
        />
      </g>
    </g>
  </svg>
);
export const externalPdfIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7"
    height="10"
    viewBox="0 0 7 10"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M7 8.59a.4.4 0 0 1-.389.41H.39A.4.4 0 0 1 0 8.59V.41A.4.4 0 0 1 .389 0h3.033v3.355a.4.4 0 0 0 .389.409H7zM4.2 2.946V.24l2.572 2.705z"
        />
      </g>
    </g>
  </svg>
);
export const fileIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="14"
    viewBox="0 0 11 14"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M11 13.364a.624.624 0 0 1-.611.636H.61A.624.624 0 0 1 0 13.364V.636C0 .285.274 0 .611 0h4.767v5.218c0 .352.273.637.61.637H11zM6.6 4.582V.372l4.042 4.21z"
        />
      </g>
    </g>
  </svg>
);
export const closeIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M9.167 7l4.747-4.747a.292.292 0 0 0 0-.413L12.16.086a.292.292 0 0 0-.412 0L7 4.833 2.252.086a.3.3 0 0 0-.412 0L.085 1.84a.292.292 0 0 0 0 .413L4.833 7 .085 11.748a.292.292 0 0 0 0 .413l1.755 1.754a.292.292 0 0 0 .412 0L7 9.167l4.748 4.748a.292.292 0 0 0 .412 0l1.755-1.754a.292.292 0 0 0 0-.413z"
        />
      </g>
    </g>
  </svg>
);
export const closedIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M7 2.478c.797 0 1.547.208 2.198.572L3.05 9.198A4.493 4.493 0 0 1 2.478 7 4.527 4.527 0 0 1 7 2.478zM11.522 7A4.527 4.527 0 0 1 7 11.522a4.493 4.493 0 0 1-2.198-.572l6.148-6.148c.364.651.572 1.4.572 2.198zM0 7c0 3.86 3.14 7 7 7s7-3.14 7-7-3.14-7-7-7-7 3.14-7 7z"
        />
      </g>
    </g>
  </svg>
);
export const refreshIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M13.444 4.284A7.06 7.06 0 0 0 11.95 2.05 7.064 7.064 0 0 0 9.716.556 6.809 6.809 0 0 0 7 0c-.893 0-1.757.168-2.593.506A7.075 7.075 0 0 0 2.18 1.932L.994.756C.81.568.602.526.364.63.123.732 0 .91 0 1.167V5.25a.56.56 0 0 0 .173.41.56.56 0 0 0 .41.173h4.084c.255 0 .434-.121.538-.364.103-.237.06-.447-.128-.63L3.828 3.583A4.628 4.628 0 0 1 7 2.333c.632 0 1.235.123 1.81.37.574.246 1.07.578 1.49.997.42.42.752.916.998 1.49.246.575.369 1.178.369 1.81 0 .632-.123 1.235-.369 1.81a4.703 4.703 0 0 1-.998 1.49c-.42.419-.916.752-1.49.998a4.547 4.547 0 0 1-1.81.369 4.598 4.598 0 0 1-2.05-.474 4.572 4.572 0 0 1-1.632-1.34c-.043-.06-.113-.097-.21-.11a.328.328 0 0 0-.228.082l-1.248 1.258a.27.27 0 0 0-.078.187.326.326 0 0 0 .06.205A6.842 6.842 0 0 0 4.02 13.34C4.962 13.78 5.955 14 7 14c.948 0 1.854-.185 2.716-.556a7.062 7.062 0 0 0 2.234-1.495 7.063 7.063 0 0 0 1.494-2.233A6.81 6.81 0 0 0 14 7a6.81 6.81 0 0 0-.556-2.716z"
        />
      </g>
    </g>
  </svg>
);
export const hintIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M9.4 6.291c-.141.199-.45.446-.838.748l-.428.295c-.235.182-.377.354-.43.523-.042.133-.062.168-.066.438v.069H6.002l.005-.138c.02-.568.034-.901.27-1.177.37-.433 1.184-.957 1.219-.98.117-.087.215-.187.288-.294.172-.236.248-.422.248-.605 0-.253-.075-.487-.224-.696-.144-.201-.415-.303-.809-.303-.39 0-.657.123-.817.377-.164.26-.247.534-.247.814v.07H4.25l.003-.073c.044-1.03.412-1.772 1.094-2.205.43-.275.963-.415 1.585-.415.815 0 1.503.198 2.045.588.549.395.827.986.827 1.758 0 .432-.136.838-.406 1.206zm-2.514 4.97h-.039c-.595-.018-1.015-.457-.998-1.043a.995.995 0 0 1 1.022-.995h.035c.612.018 1.027.453 1.01 1.056-.018.578-.44.982-1.03.982zm.02-11.26a7 7 0 1 0 .189 14 7 7 0 0 0-.189-14z"
        />
      </g>
    </g>
  </svg>
);
export const sortIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="13"
    viewBox="0 0 12 13"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M11.882 2.962L9.307.322a.399.399 0 0 0-.573 0l-2.575 2.64a.423.423 0 0 0 0 .588l.286.294a.4.4 0 0 0 .573 0l1.394-1.43v9.37c0 .23.182.416.406.416h.405a.41.41 0 0 0 .405-.416v-9.37l1.394 1.43a.4.4 0 0 0 .573 0l.287-.294a.423.423 0 0 0 0-.588zM5.842 8.85l-.287-.294a.4.4 0 0 0-.573 0l-1.394 1.43V.616A.41.41 0 0 0 3.183.2h-.405a.41.41 0 0 0-.406.416v9.37L.978 8.556a.4.4 0 0 0-.573 0L.12 8.85a.423.423 0 0 0 0 .588l2.575 2.64a.399.399 0 0 0 .573 0l2.575-2.64a.423.423 0 0 0 0-.588z"
        />
      </g>
    </g>
  </svg>
);
export const orderAscIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M11.883 9.285l-2.53 2.595a.392.392 0 0 1-.564 0L6.258 9.285a.416.416 0 0 1 0-.578l.281-.289a.393.393 0 0 1 .564 0l1.37 1.405V.613c0-.226.178-.409.398-.409h.399c.22 0 .398.183.398.409v9.21l1.37-1.405a.394.394 0 0 1 .564 0l.281.29a.416.416 0 0 1 0 .577zM5.95 1.225H.398A.404.404 0 0 1 0 .818V.409C0 .183.178 0 .398 0H5.95c.22 0 .399.183.399.409v.408a.404.404 0 0 1-.399.409zM5.6 2.983v.409a.404.404 0 0 1-.398.408H.398A.404.404 0 0 1 0 3.391v-.409c0-.225.178-.408.398-.408h4.804c.22 0 .399.183.399.408zm-.748 2.57v.406a.402.402 0 0 1-.398.405H.398A.402.402 0 0 1 0 5.958v-.406c0-.223.178-.405.398-.405h4.056c.22 0 .398.182.398.405zm-.748 2.86v.405a.402.402 0 0 1-.398.405H.398A.402.402 0 0 1 0 8.817v-.405c0-.224.178-.405.398-.405h3.308c.22 0 .398.181.398.405zm-.748 2.577v.409a.404.404 0 0 1-.398.408H.398A.404.404 0 0 1 0 11.398v-.409c0-.226.178-.408.398-.408h2.56c.22 0 .398.182.398.408z"
        />
      </g>
    </g>
  </svg>
);
export const orderDescIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M11.883 2.715L9.353.12a.392.392 0 0 0-.564 0L6.258 2.715a.416.416 0 0 0 0 .578l.281.289a.393.393 0 0 0 .564 0l1.37-1.405v9.21c0 .226.178.409.398.409h.399c.22 0 .398-.183.398-.409v-9.21l1.37 1.405a.394.394 0 0 0 .564 0l.281-.29a.416.416 0 0 0 0-.577zm-5.933 8.06H.398a.404.404 0 0 0-.398.408v.408c0 .226.178.409.398.409H5.95c.22 0 .399-.183.399-.409v-.408a.404.404 0 0 0-.399-.409zM5.6 9.017v-.409a.404.404 0 0 0-.398-.408H.398A.404.404 0 0 0 0 8.609v.409c0 .225.178.408.398.408h4.804c.22 0 .399-.183.399-.408zm-.748-2.57v-.406a.402.402 0 0 0-.398-.405H.398A.402.402 0 0 0 0 6.042v.406c0 .223.178.405.398.405h4.056c.22 0 .398-.182.398-.405zm-.748-2.86v-.405a.402.402 0 0 0-.398-.405H.398A.402.402 0 0 0 0 3.183v.405c0 .224.178.405.398.405h3.308c.22 0 .398-.181.398-.405zM3.356 1.01V.602a.404.404 0 0 0-.398-.408H.398A.404.404 0 0 0 0 .602v.409c0 .226.178.408.398.408h2.56c.22 0 .398-.182.398-.408z"
        />
      </g>
    </g>
  </svg>
);

export const bellIcon: IIconComponent = () => (
  <svg height="14" viewBox="0 0 511.156 511.156" width="14" fill="currentColor">
    <path d="m184.904 465.044c11.999 27.127 39.154 46.112 70.674 46.112s58.674-18.985 70.674-46.112z" />
    <path d="m255.573 48.836c20.8 0 40.772 3.67 59.306 10.389v-2.283c0-31.398-25.544-56.942-56.941-56.942h-4.719c-31.398 0-56.942 25.544-56.942 56.942v2.254c18.524-6.699 38.49-10.36 59.296-10.36z" />
    <path d="m442.747 435.044h-374.338c-7.082 0-13.569-4.776-15.042-11.704-1.458-6.859 1.668-13.629 8.01-16.559 1.505-.976 12.833-8.897 24.174-32.862 20.829-44.01 25.201-106.005 25.201-150.263 0-79.855 64.967-144.82 144.821-144.82 79.665 0 144.512 64.652 144.82 144.245.007.191.011.383.011.575 0 44.258 4.372 106.253 25.201 150.263 11.341 23.965 22.668 31.887 24.174 32.862 6.342 2.93 9.469 9.699 8.01 16.559-1.473 6.927-7.959 11.704-15.042 11.704zm7.2-28.157h.01z" />
  </svg>
);

export const errorIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 12 12"
  >
    <g>
      <g>
        <path
          fill="#e87171"
          d="M7.093 6.214c0 .608-.493 1.103-1.098 1.103a1.102 1.102 0 0 1-1.098-1.103V2.719c0-.608.493-1.103 1.098-1.103.605 0 1.098.495 1.098 1.103zM6 10.384a1.103 1.103 0 0 1-1.101-1.101c0-.608.494-1.102 1.1-1.102a1.103 1.103 0 0 1 0 2.203zM6 0C2.692 0 0 2.692 0 6s2.692 6 6 6 6-2.692 6-6-2.692-6-6-6z"
        />
      </g>
    </g>
  </svg>
);

export const lockIcon: IIconComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="12"
    viewBox="0 0 10 12"
  >
    <g>
      <g>
        <path
          fill="#55555580"
          d="M2.611 3.604c0-1.118.91-2.025 2.026-2.025 1.118 0 2.025.91 2.025 2.025v1.253h-4.05zm2.56 5.056c-.073.054-.093.106-.093.192.003.385.003.767.003 1.152a.41.41 0 0 1-.216.388.45.45 0 0 1-.672-.388c0-.387 0-.772.002-1.157 0-.079-.017-.13-.085-.182a.878.878 0 0 1-.29-1.081.898.898 0 0 1 .974-.517c.434.088.735.436.74.87a.85.85 0 0 1-.363.723zM1.035 3.604v1.253H.95A.952.952 0 0 0 0 5.81v5.24c0 .524.427.951.951.951h7.312a.952.952 0 0 0 .952-.951V5.806a.952.952 0 0 0-.952-.951H8.24V3.602A3.606 3.606 0 0 0 4.637 0a3.61 3.61 0 0 0-3.602 3.604z"
        />
      </g>
    </g>
  </svg>
);
